"use strict";
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolvePayments = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const commerce_cart_1 = require("@broadleaf/commerce-cart");
const internal_1 = require("./internal");
const useResolvePayments = ({ ownerId, paymentClient, setPayments, ownerType, authState, options }) => {
    const [resolving, setResolving] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const getCustomerToken = (0, internal_1.useGetCustomerAccessToken)({ authState });
    const refetchPayments = (0, react_1.useCallback)(() => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        var _a;
        if (!ownerId) {
            return;
        }
        const accessToken = yield getCustomerToken();
        let payments = undefined;
        try {
            setResolving(true);
            if (ownerId) {
                const owningUserType = authState.accountId != undefined
                    ? commerce_cart_1.DefaultPaymentOwningUserType.BLC_ACCOUNT
                    : commerce_cart_1.DefaultPaymentOwningUserType.BLC_CUSTOMER;
                // otherwise, if we're authenticated, get the customer's cart
                payments = yield paymentClient.fetchAllPaymentsForOwner(ownerId, ownerType, Object.assign(Object.assign({}, options), { accessToken }), owningUserType);
            }
            setPayments(payments);
            setError(undefined);
        }
        catch (err) {
            if (axios_1.default.isCancel(err)) {
                // do nothing if cancelled
                return;
            }
            if (axios_1.default.isAxiosError(err)) {
                setError((_a = err.response) === null || _a === void 0 ? void 0 : _a.data);
            }
            console.error('Encountered an error resolving the payments', err);
            setPayments(undefined);
        }
        finally {
            setResolving(false);
        }
    }), [
        ownerId,
        ownerType,
        options,
        paymentClient,
        setPayments,
        getCustomerToken
    ]);
    (0, react_1.useEffect)(() => {
        refetchPayments();
    }, [refetchPayments]);
    return { resolving, error, refetchPayments };
};
exports.useResolvePayments = useResolvePayments;
//# sourceMappingURL=use-resolve-payments.js.map